export default {
  nav: {
    brand: 'JK 工作室',
    service: '服務項目',
    projects: '開發專案',
    pricing: '報價方式',
    about: '關於工作室',
    contact: '聯絡我們',
    langLabel: 'TW',
    langZhTW: '繁體中文',
    langEn: 'English',
  },
  masthead: {
    subtitle: 'PHP 全端網站開發、維護及雲端佈署',
  },
  service: {
    heading: '打造您的客製化網路服務',
    body: '我們的服務項目包含：開發各式網站如企業形象、內容管理、活動、商城、社群、API服務等。<br />依設計稿製作 RWD 前端頁面。維護現有PHP網站。雲端佈署。網站資料庫定期備份。<br />我們<span class="text-danger">沒有提供</span>視覺設計服務。<span class="text-danger">無法</span>開立發票。<br />歡迎設計師及專案公司商談長期配合。',
    imgAlt: 'JK 工作室服務展示',
  },
  projects: {
    heading: '開發專案',
    intro: '所有專案均有測試網站，但因包含個資或網站屬於他人所有，無法公開於網際網路，只能放置截圖。如果想要了解更多站台細節或實際操作，請與我們聯絡。',
    hint: '點擊縮圖可開啟圖片集',
    gallery: {
      cvilux: {
        title: '產品官網',
        alt: '產品官網 Cvilux 網站截圖',
        body: '於傳產公司任職時獨力開發之網站。<br />這個網站的前台沒有找設計師做設計稿，而是以 Bootstrap 為底，再請公司的工業設計師同仁支援，提供視覺建議及素材而建立起來。<br />後端則是用開源的管理後台樣式做為版面，客製所有功能。<br /><a href="https://www.cvilux.com" target="_blank">網站連結</a><br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      herbalshake: {
        title: '活動網站',
        alt: '活動網站截圖',
        body: '承接設計公司外包的專案，為其製作後端程式、設計資料庫，雲端佈署。<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      ezmaster: {
        title: '教學平台',
        alt: '教學平台網站截圖',
        body: '案主提供前台已製作好之版面及功能需求，由我方實作功能、管理後台、設計資料庫。<br />後台版面使用 Bootstrap 預設樣式<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      transportation: {
        title: '管理系統',
        alt: '出貨管理系統截圖',
        body: '簡易的出貨單、司機、客戶資料管理系統。<br />直接使用 Bootstrap 預設樣式建立版面。<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      rdm: {
        title: '企業形象',
        alt: '企業形象網站截圖',
        body: '承接設計師外包之設計稿轉為前端頁面之靜態網站。<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      petid: {
        title: '商品銷售',
        alt: '商品銷售網站截圖',
        body: '案主自行創業而發包的網站，第一版由案主提供自行繪製的畫面設計稿，我方製作功能、後台、設計資料庫。購物功能不含金流。<br />後台版面使用 Bootstrap 預設樣式<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      pi2: {
        title: '前台改版',
        alt: '商品銷售網站前台改版截圖',
        body: '商品銷售網站之案主另行外包前台版面設計後重新套版。<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      edm: {
        title: 'EDM 管理',
        alt: 'EDM 電子報管理系統截圖',
        body: '於展覽公司任職時開發之專案。提供活動管理同仁管理 EDM 之內容設定、發送測試、投遞對象、黑名單等。設定發送時間後會由 SMTP server 按排定時間發送。<br />版面使用 Bootstrap 預設樣式<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      tte2014: {
        title: '活動網站',
        alt: '展覽活動網站截圖',
        body: '於展覽公司任職時開發之專案。由設計師同仁設計前台版面，製作前後台頁面、開發程式功能及資料庫。<br />後台版面使用 Bootstrap 預設樣式<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      kaley: {
        title: '形象網站',
        alt: '企業形象網站 RWD 前端截圖',
        body: '由案主提供 Zeplin 設計稿，我方製作成 RWD 前端靜態頁面。<br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
      greenewera: {
        title: '宣導網站',
        alt: 'Greenewera 3D 環景宣導網站截圖',
        body: '使用 Babylon.js 函式庫製作之 RWD 宣導及活動網站。以環景攝影方式呈現 3D 場景。<br /><a href="https://greenewera.com.tw/2021" target="_blank">網站連結</a><br /><small class="text-warning">點擊縮圖可開啟圖片集</small>',
      },
    },
  },
  pricing: {
    heading: '關於報價及付款',
    body: '<span class="text-warning">我們必須先詳細瞭解您的需求才有辦法報價。</span><br />在您與我們聯繫之後，我們會先完整了解系統的功能細節，評估所要花費的時間，再提供時程及報價。<br />專案成立時，會與您簽訂合約，簽約後需先支付30%的款項，系統完成時支付50%，驗收後再支付最後的20%。若是幾個工作天就可以完成的小型需求則不在此限。',
  },
  about: {
    heading: '關於工作室',
    body: '擁有 18 年以上 PHP/Laravel 與 Vue.js 全端開發經驗，專注於生產級 Web 應用程式的開發與交付。<br /><br />承接過多元類型的專案——電商平台、REST API、後台管理系統、物流系統、即時聊天功能，以及以 Babylon.js 建構的 3D 虛擬展場。從後端架構、資料庫設計、前端實作，到 AWS 部署與 CI/CD 流程建置，可獨立負責專案的完整生命週期。<br /><br />如果您需要一個能夠全程主導專案、不需要手把手帶領的開發者，歡迎與我們聯繫。',
  },
  contact: {
    heading: '聯絡我們',
  },
  footer: {
    credit: '本站版面設計使用 Bootstrap4 免費布景主題 <a href="http://startbootstrap.com/template-overviews/grayscale/" target="_blank">Grayscale</a> 加以修改',
    copyright: 'Copyright © JK Web Studio 2026',
  },
}
